import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for Heading:
 * slots: root, subline, headline, headline1, headline2
 * variants:
 *  - dualTone: true | false
 *  - separateLines: true | false
 *  - variant: default | small
 */

export default defineSlotRecipe({
    slots: ['root', 'subline', 'headline', 'headline1', 'headline2'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: 6,
            color: 'text.primary'
        },
        headline: {display: 'block'},
        subline: {
            color: 'text.brand-default',
            textStyle: 'labels.mediumCaps'
        }
    },
    variants: {
        dualTone: {
            true: {
                headline1: {color: 'text.primary'},
                headline2: {color: 'text.secondary'}
            }
        },
        separateLines: {
            true: {
                headline1: {display: 'block'},
                headline2: {display: 'block'}
            },
            false: {
                headline1: {display: 'inline'},
                headline2: {display: 'inline'}
            }
        },
        variant: {
            // designed based on awards module - https://www.figma.com/design/54EbshuMlvuqCBKFYoAhHg/STOKKE-Design-System?node-id=1345-10304&m=dev
            small: {
                root: {
                    textStyle: 'heading.large'
                },
                subline: {display: 'none'},
                headline2: {display: 'none'}
            },
            default: {
                root: {
                    textStyle: 'display.small'
                }
            }
        }
    },
    defaultVariants: {
        alignment: 'left',
        dualTone: 'true',
        separateLines: 'true',
        variant: 'default'
    }
})
